import type { Translate } from '@/i18n'

// Mirrors the backend rule (core/user.go validAdminPassword):
// 6–72 bytes with at least one uppercase, one lowercase and one digit.
// A Контрагент login gets its password from the partner: length only.
export function passwordProblem(password: string, t: Translate, lengthOnly = false): string | null {
  const bytes = new TextEncoder().encode(password).length
  if (bytes < 6 || bytes > 72) return t('validation.passwordLength')
  if (lengthOnly) return null
  // Name only what is missing: «Добавьте заглавную букву.», not all three.
  const missing = [
    !/[A-Z]/.test(password) && t('validation.passwordParts.upper'),
    !/[a-z]/.test(password) && t('validation.passwordParts.lower'),
    !/\d/.test(password) && t('validation.passwordParts.digit'),
  ].filter((part): part is string => Boolean(part))
  if (missing.length === 0) return null
  const last = missing.pop() as string
  const parts = missing.length ? `${missing.join(', ')} ${t('validation.passwordParts.and')} ${last}` : last
  const text = t('validation.passwordAdd', { parts })
  return text.charAt(0).toUpperCase() + text.slice(1)
}
